import BaseAPI from "./base/base-api";

class EmployeeStatusAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "EmployeeStatus";
}

export default new EmployeeStatusAPI();
